import React from 'react';
import './crash.scss';
import { FormattedMessage } from 'react-intl';
import { CrashMessage } from './CrashMessage';
import { CrashMessageHeader } from './CrashMessageHeader';
import { CrashMessageContainer } from './CrashMessageContainer';
import { CrashMessageFooter } from './CrashMessageFooter';
import { IncompatibleBrowser } from '../../common/components/incompatible-browser/IncompatibleBrowser';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

const browserSupport: number = window.browser_support;

export class Crash extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error) {
    console.log(error);
    // We don't report error for incompatible browsers
    if (window.Rollbar && browserSupport > 0)
      window.Rollbar.critical(error, { source: 'global page' });
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (browserSupport === 0) {
      return <IncompatibleBrowser />;
    }

    if (this.state.hasError) {
      return (
        <div className="crash">
          <CrashMessageContainer>
            <CrashMessageHeader>
              <FormattedMessage id="components/crash/Crash.tsx/1" />
            </CrashMessageHeader>
            <CrashMessage />
            <CrashMessageFooter />
          </CrashMessageContainer>
        </div>
      );
    }

    return this.props.children;
  }
}
